import React, { useEffect, useRef } from "react";
import {
  Button,
  Divider,
  Tooltip,
} from "antd";
import {
  BoldOutlined,
  ItalicOutlined,
  UnderlineOutlined,
  UnorderedListOutlined,
  OrderedListOutlined,
  LineOutlined,
} from "@ant-design/icons";

const SimpleEditor = ({ value, onChange, placeholder }) => {
  const editorRef = useRef(null);

  useEffect(() => {
    if (editorRef.current && editorRef.current.innerHTML !== value) {
      editorRef.current.innerHTML = value;
    }
  }, [value]);

  const handleInput = () => {
    if (editorRef.current) {
      onChange(editorRef.current.innerHTML);
    }
  };

  const applyFormat = (command, value = null) => {
    document.execCommand(command, false, value);
    editorRef.current?.focus();
  };

  return (
    <div className="border border-gray-300 rounded-lg overflow-hidden">
      <div className="bg-gray-100 p-3 flex gap-2 flex-wrap border-b border-gray-300">
        <Tooltip title="Bold">
          <Button
            size="small"
            type="text"
            icon={<BoldOutlined />}
            onClick={() => applyFormat("bold")}
          />
        </Tooltip>
        <Tooltip title="Italic">
          <Button
            size="small"
            type="text"
            icon={<ItalicOutlined />}
            onClick={() => applyFormat("italic")}
          />
        </Tooltip>
        <Tooltip title="Underline">
          <Button
            size="small"
            type="text"
            icon={<UnderlineOutlined />}
            onClick={() => applyFormat("underline")}
          />
        </Tooltip>
        <Divider type="vertical" />
        <Tooltip title="Bullet list">
          <Button
            size="small"
            type="text"
            icon={<UnorderedListOutlined />}
            onClick={() => applyFormat("insertUnorderedList")}
          />
        </Tooltip>
        <Tooltip title="Numbered list">
          <Button
            size="small"
            type="text"
            icon={<OrderedListOutlined />}
            onClick={() => applyFormat("insertOrderedList")}
          />
        </Tooltip>
        <Divider type="vertical" />
        <Tooltip title="Line break">
          <Button
            size="small"
            type="text"
            icon={<LineOutlined />}
            onClick={() => applyFormat("insertHTML", "<br/>")}
          />
        </Tooltip>
      </div>
      <div
        ref={editorRef}
        contentEditable
        onInput={handleInput}
        className="w-full p-4 min-h-64 outline-none overflow-auto"
        style={{
          maxHeight: "400px",
          whiteSpace: "pre-wrap",
          wordWrap: "break-word",
          fontSize: "16px",
        }}
        suppressContentEditableWarning
      >
        {placeholder}
      </div>
    </div>
  );
};

export default SimpleEditor;
